// apps/web/src/features/crm/leads/list/engagementBucketMeta.ts
//
// Wire↔UI bridge for the `GET /engagements` bucket chips (#2247 FR-1). Defines
// the chip order and maps each wire-only `EngagementBucket` token to its
// `EngagementBucketCounts` field. The human labels live in i18n and are resolved
// at the chip call site — never the enum token literally, never "Engagement" (D-A).
import { EngagementBucket, type EngagementBucketCounts } from '@magimp/shared';

/** Chip order left-to-right (BR-3: the No-client bucket is a bucket, not a column). */
export const ENGAGEMENT_BUCKET_ORDER: readonly EngagementBucket[] = [
  EngagementBucket.ALL,
  EngagementBucket.NEW,
  EngagementBucket.IN_WORK,
  EngagementBucket.CLOSING,
  EngagementBucket.DEAL,
  EngagementBucket.POSTPONED,
  EngagementBucket.NO_CLIENT,
  EngagementBucket.CLOSED,
] as const;

export const ENGAGEMENT_SCOPE_BUCKET_ORDER: readonly EngagementBucket[] = [
  EngagementBucket.ALL,
  EngagementBucket.UNASSIGNED,
  ...ENGAGEMENT_BUCKET_ORDER.slice(1),
] as const;

/** Server-computed count field backing a bucket's chip counter. */
export function bucketCount(bucket: EngagementBucket, counts: EngagementBucketCounts): number {
  const map: Record<EngagementBucket, keyof EngagementBucketCounts> = {
    [EngagementBucket.ALL]: 'all',
    [EngagementBucket.UNASSIGNED]: 'unassigned',
    [EngagementBucket.NEW]: 'new',
    [EngagementBucket.IN_WORK]: 'inWork',
    [EngagementBucket.CLOSING]: 'closing',
    [EngagementBucket.DEAL]: 'deal',
    [EngagementBucket.POSTPONED]: 'postponed',
    [EngagementBucket.NO_CLIENT]: 'noClient',
    [EngagementBucket.CLOSED]: 'closed',
  };
  return counts[map[bucket]] ?? 0;
}
